import { render, staticRenderFns } from "./RegistryActionPanel.vue?vue&type=template&id=38ad124a&scoped=true"
import script from "./RegistryActionPanel.vue?vue&type=script&lang=js"
export * from "./RegistryActionPanel.vue?vue&type=script&lang=js"
import style0 from "./RegistryActionPanel.vue?vue&type=style&index=0&id=38ad124a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ad124a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38ad124a')) {
      api.createRecord('38ad124a', component.options)
    } else {
      api.reload('38ad124a', component.options)
    }
    module.hot.accept("./RegistryActionPanel.vue?vue&type=template&id=38ad124a&scoped=true", function () {
      api.rerender('38ad124a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/registry/RegistryActionPanel.vue"
export default component.exports